export default __webpack_public_path__ + "static/media/26_4_1.dbec433d.png";